import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './contexts/AuthContext';
import { useTranslation } from 'react-i18next';

// Styles
import './styles/App.css';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';

// Service Pages
import CustomDesign from './pages/services/CustomDesign';
import Restoration from './pages/services/Restoration';
import MoldDesign from './pages/services/MoldDesign';

const App: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.dir();
  }, [i18n, i18n.language]);

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="app-root">
          <Navigation />
          <main className="app-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services/custom-design" element={<CustomDesign />} />
              <Route path="/services/restoration" element={<Restoration />} />
              <Route path="/services/mold-design" element={<MoldDesign />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App; 